import { render, staticRenderFns } from "./booking-select-info.vue?vue&type=template&id=97909226&scoped=true&"
import script from "./booking-select-info.ts?vue&type=script&lang=ts&"
export * from "./booking-select-info.ts?vue&type=script&lang=ts&"
import style0 from "./booking-select-info.scss?vue&type=style&index=0&id=97909226&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97909226",
  null
  
)

export default component.exports